import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleRequest } from "../../http/http";
import { useState } from "react";
import * as Yup from "yup";

import Company from "../../components/Company";
import ContactPerson from "../../components/ContactPerson";

import {
  participantValidation,
  contactPersonValidation,
} from "../../schemas/validationSchema.js";
import { podjetjeValidation } from "../../schemas/validationSchemaCompany.js";
import { emptyParticipant } from "./registration.config";
import Participants from "../../components/Participants.jsx";
import { useNavigate } from "react-router-dom";
import { jsonCreateCompany } from "../../util/jsonCreate.js";

import Captcha from "../../components/Captcha.jsx";
import FormPrompt from "../../components/FormPrompt.jsx";
import Header from "../../components/Header.jsx";
import Infos from "../../components/Infos.jsx";
import ConfirmModal from "../../components/ConfirmModal.jsx";
import scrollToTop from "../../util/scrollToTop.js";
import { Col, Container, Row } from "react-bootstrap";
import SocialIcons from "../../components/SocialIcons/SocialIcons.jsx";

export default function Registration() {
  // const url_regular = process.env.REACT_APP_URL_REGULAR;
  const url_regular_https = process.env.REACT_APP_URL_REGULAR_HTTPS;

  let validationSchema = { ...podjetjeValidation };

  const [participants, setParticipants] = useState([{ ...emptyParticipant }]);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [errorCaptcha, setErrorCaptcha] = useState("");
  const [onlineError, setOnlineError] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingData, setPendingData] = useState(null);
  const [sending, setSending] = useState(false);

  const navigate = useNavigate();

  const generateValidationSchema = () => {
    for (let i = 1; i <= participants.length; i++) {
      validationSchema[`firstName${i}`] = participantValidation[`firstName`];
      validationSchema[`lastName${i}`] = participantValidation[`lastName`];
      validationSchema[`email${i}`] = participantValidation[`email`];
    }
    if (participants.length > 1) {
      validationSchema = { ...validationSchema, ...contactPersonValidation };
    }

    return Yup.object(validationSchema);
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, dirtyFields, isSubmitting },
  } = useForm({
    resolver: yupResolver(generateValidationSchema()),
  });

  const onSubmit = (data) => {
    setOnlineError(false);
    if (captchaValue === null) {
      setErrorCaptcha("Morate označiti, da niste robot.");
      return;
    }
    setPendingData(jsonCreateCompany(data, participants));
    setShowConfirm(true);
  };

  const handleConfirmSend = async () => {
    setSending(true);
    setOnlineError(false);
    try {
      const response = await handleRequest(
        url_regular_https,
        pendingData,
        captchaValue
      );
      if (response.status === 200) {
        navigate("/uspesno-poslano/podjetje", {
          replace: true,
          state: pendingData,
        });
      }
    } catch (error) {
      console.warn(error);
      setOnlineError(true);
      setShowConfirm(false);
      scrollToTop();
    } finally {
      setSending(false);
    }
  };

  const handleCancelSend = () => {
    setShowConfirm(false);
  };

  function addParticipant() {
    participants.push({ ...emptyParticipant });
    setParticipants([...participants]);
  }

  function removeParticipant(id) {
    participants.splice(id - 1, 1);
    setParticipants([...participants]);
  }

  function handleChange(value) {
    setCaptchaValue(value);
  }

  return (
    <>
      <Container fluid>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <Header url=""/>
          </Col>
        </Row>
        <Row>
          <Col md={{ offset: 3, span: 6 }}>
            <div className="title-box">
              <p>Prijava na konferenco OTS</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <div className="heading">
              <p>Za prijavo na konferenco izpolnite spodnji obrazec.</p>
              <p>
                Prijava velja kot naročilnica. Račun za plačilo kotizacije bo
                izstavljen po izvedbi konference.
              </p>
            </div>
          </Col>
          <Col>
            <SocialIcons />
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <form
              id="my-form"
              className="obrazec"
              onSubmit={handleSubmit(onSubmit)}
            >
              <FormPrompt
                hasUnsavedChanges={isDirty}
                dirtyFields={dirtyFields}
              />

              <div className="div">
                <div className="row-error">
                  <Infos
                    isSubmitting={isSubmitting || sending}
                    onlineError={onlineError}
                  />
                </div>
                <Company errors={errors} register={register} />
              </div>

              <Participants
                errors={errors}
                participants={participants}
                handleRemoveParticipant={removeParticipant}
                register={register}
              />

              {participants.length > 1 && (
                <ContactPerson errors={errors} register={register} />
              )}

              <Captcha handleChange={handleChange} error={errorCaptcha} />

              <Row className="pt-4 d-grid gap-3 d-sm-grid gap-sm-3 d-md-flex gap-md-0">
                <Col md={6}>
                  <div className="d-flex justify-content-center justify-content-md-center justify-content-lg-start">
                    <input
                      type="button"
                      className="add-participant"
                      value="Dodaj udeleženca/udeleženko"
                      onClick={addParticipant}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex justify-content-center justify-content-md-center justify-content-lg-end">
                    <input
                      type="submit"
                      className="primary-button"
                      value="Pošlji prijavo"
                    />
                  </div>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        show={showConfirm}
        onConfirm={handleConfirmSend}
        onCancel={handleCancelSend}
        sending={sending}
      />
      <img className="bottomImg" src="images/bottom-bg.png" alt="" />
    </>
  );
}
